module.exports = __webpack_public_path__ + "index/img/kf_bg.be3095ab.png";